/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Metadata_Required_ErrorInputs */



/**
* | output |
* | --- |
* | "Please fill in all required fields." |
*
* @param {Iconik_Metadata_Required_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_required_error = /** @type {((inputs?: Iconik_Metadata_Required_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_Required_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Please fill in all required fields.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Please fill in all required fields.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Please fill in all required fields.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Please fill in all required fields.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Please fill in all required fields.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Please fill in all required fields.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Please fill in all required fields.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Please fill in all required fields.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Please fill in all required fields.")
	return /** @type {LocalizedString} */ ("Please fill in all required fields.")
});